import { useEffect } from 'react';
import { prop, pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector, useGameConfigurationSelector, useUserSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { workerService } from 'js/services/worker.service';

import * as actions from '../../store/actions';

export const useGetOldGamesFeeds = () => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const dispatch = useDispatch();
    const lang = useUserSelector(prop('lang'));
    const {
        requestStamp,
        isOldGamesFeedsLoaded,
        oldGamesFeeds
    } = useAppSelector(pick(['requestStamp', 'isOldGamesFeedsLoaded', 'oldGamesFeeds']));
    const excludedGameCodes = useGameConfigurationSelector(prop('excludedGameCodes'));
    const prevExcludedGameCodes = usePrevious(excludedGameCodes);

    useEffect(() => {
        if (!isOldGamesFeedsLoaded) {
            return;
        }

        if (prevExcludedGameCodes === excludedGameCodes) {
            return;
        }

        (async () => {
            const newOldGamesFeeds = await workerService.request('gameFeedParse', {
                oldGamesFeeds,
                excludedGameCodes
            });

            dispatch(actions.updateOldGamesFeeds(newOldGamesFeeds));
        })();
    }, [
        dispatch,
        prevExcludedGameCodes,
        oldGamesFeeds,
        excludedGameCodes,
        isOldGamesFeedsLoaded
    ]);

    useEffect(() => {
        if (!lang || isOldGamesFeedsLoaded) {
            return;
        }

        (async () => {
            const requestURL = getCMSResourceURL(`/initialResources/games/${lang}`, { t: requestStamp });
            const newOldGamesFeeds = await workerService.request('gameFeeds', { url: requestURL, excludedGameCodes });

            dispatch(actions.updateOldGamesFeeds(newOldGamesFeeds));
        })();
    }, [
        dispatch,
        lang,
        requestStamp,
        getCMSResourceURL,
        isOldGamesFeedsLoaded,
        excludedGameCodes
    ]);
};
